import { inputCustomizedProps } from "./types/inputProps";
import './input.scss';
import "../../../helpers/validation/validation.scss";
import { AdditionalIcon } from "../additionalIcon/additionalIcon";
import Spinner from "../../spinner/spinner";
import { ClassNameSpinner } from "../../spinner/types/spinnerProps";
import { useEffect, useRef, useState } from "react";
import useAutosizeTextArea from "../../../helpers/textareHeight";
import { ReactComponent as addCircle } from '../../../icons/add_circle.svg';
import { adjustHeight } from "../../../helpers/domHelper";

const Input = (props: inputCustomizedProps) => {
  var iconStyle: React.CSSProperties = {
    display: props.displayIcon
  }
  if (props.iconStyle) iconStyle = props.iconStyle;
  const [value, setValue] = useState(props.props?.value !== null && props.props?.value !== undefined ? props.props?.value : "");

  useEffect(() => {
    let _value = props.props?.value !== null && props.props?.value !== undefined ? props.props?.value : "";
    setValue(_value);
  }, [props.props?.value, props.props?.type])

  const onChange = (event: any) => {
    setValue(event.target.value);
    if (props.props?.onChange) props.props?.onChange(event);
  }

  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useAutosizeTextArea(textAreaRef.current, props.props?.value);

  const handleAddComment = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (props.addCommentBtn) {
      props.addCommentBtn.onClick(e);
      setTimeout(() => {
        adjustHeight(textAreaRef.current);
      }, 500);
    }
  }

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (props.onClickFilterComments) {
       props.onClickFilterComments(e);
    }
    if (props.textarea) {
      adjustHeight(textAreaRef.current);
    }
  }

  return (
    <div onClick={handleClick} ref={props.inputRef} className={props.className ? props.className : "inputWrapper"}>
      {props.textarea ? <textarea autoFocus={props.autoFocus} onKeyDown={props.onKeyDown} ref={textAreaRef} rows={1} {...props.props} value={props.props?.value ? props.props.value : ""}
        className={`${props.props?.className} ${props.isMarkedForCommentFilter ? "markedForCommentFilter" : ""}`} /> :
        <input autoFocus={props.autoFocus} onKeyDown={props.onKeyDown} onWheel={(e) => (e.target as HTMLElement).blur()} {...props.props} value={value} onChange={onChange}
          className={`${props.props?.className} ${props.isMarkedForCommentFilter ? "markedForCommentFilter" : ""}`} />}
      {props.addCommentBtn?.visible &&
        <div className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.isMarkedForCommentFilter ? "activeAddCommentBtn" : ""}`} onClick={handleAddComment}>
          {AdditionalIcon(addCircle)}
        </div>
      }
      {props.searching && <div className="inputSpinner">
        <Spinner spinnerClass={ClassNameSpinner.Small} />
      </div>}
      {!props.searching && AdditionalIcon(props.additionalIcon, iconStyle, props.classNameIcon)}
    </div>
  )
}

export default Input;